module.exports = __webpack_public_path__ + "img/img_size4_jf.6515d69f.png";